import moment from 'moment-timezone';

// TODO: after component library is released use the method from DateService instead
export const DateServiceTemp = {
  /**
   * Converts a date to a specific timezone.
   * @param date The date to be converted. It can be a string or a Date object.
   * @param timezone The target timezone for the conversion.
   * It should be a string representing a valid IANA timezone.

   * For a list of all valid IANA timezones, you can use `moment.tz.names()`.
   *
   * @returns A string representing the date converted to the target timezone.
   *
   * @throws An error if the provided timezone is not a valid IANA timezone.
   */
  convertDateToTimeZone(date: string | Date, timezone: string) {
    const momentInstance = moment(date).tz(timezone);
    return momentInstance.format();
  },
};
